import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCollaborationPointerLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCollaborationPointerLeft"><Path d="M12.5 12.5L20 9.5L4.5 4.5L9.5 20L12.5 12.5Z" stroke="currentColor"/><Path d="M20.9998 13.2998L15.4998 15.4998L13.2998 20.9998" stroke="currentColor"/></CentralIconBase>;
});

export default IconCollaborationPointerLeft;
